import { render, staticRenderFns } from "./MixerLoadsDetail.vue?vue&type=template&id=37fa8f68&scoped=true&lang=pug&"
import script from "./MixerLoadsDetail.vue?vue&type=script&lang=js&"
export * from "./MixerLoadsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MixerLoadsDetail.vue?vue&type=style&index=0&id=37fa8f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa8f68",
  null
  
)

export default component.exports